export const IS_LOADING_STORAGE_KEY = "is_loading";
